module.exports = __webpack_public_path__ + "static/media/list-of-users-white.80014c76.svg";